import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../../api/authService';
import { SessionTimeoutModal } from './SessionTimeoutModal';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const checkUser = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (token) {
          // If we have local profile data, use it immediately to prevent UI blocking
          const storedUser = localStorage.getItem('user_profile');
          if (storedUser) {
            try {
              setUser(JSON.parse(storedUser));
            } catch (e) {
              console.error("Error parsing stored user", e);
            }
          }
          
          // Always try to fetch fresh data
          const userData = await authService.getMe();
          setUser(userData);
        }
      } catch (error) {
        console.error('Auth verification failed:', error);
        // If getting me fails (e.g. refresh token expired), clear everything
        authService.clearTokens();
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, []);

  const login = async (loginVar, password) => {
    const data = await authService.login(loginVar, password);
    const userData = await authService.getMe();
    setUser(userData);
    return data;
  };

  const logout = async () => {
    await authService.logout();
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    setUser
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
      <SessionTimeoutModal />
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
